import ChatConnectRoomItem from './ChatConnectRoomItem';

export default ChatConnectRoomItem;
